/**
 * GFM table nodes for the scene editor/reader — the client mirror of the
 * server's set in api/src/utils/tiptap/tiptapContent.ts (TableWithWidth +
 * TableRow/TableCell/TableHeader). The four node names MUST match the server so
 * ProseMirror docs round-trip identically; a drift-guard test enforces it.
 *
 * Column alignment round-trips for free (cell/header parse `text-align`); only
 * the table-level Leanpub `{width:"…"}` needs an added attribute, kept as a
 * sanitizer-safe inline `style` (a `data-*` width would be stripped in preview).
 */
import {Table, TableRow, TableCell, TableHeader} from '@tiptap/extension-table';

export const TableWithWidth = Table.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      width: {
        default: null,
        parseHTML: element => element.style.width || null,
        renderHTML: attributes =>
          attributes.width ? {style: `width:${attributes.width}`} : {}
      }
    };
  }
});

export function buildTableExtensions() {
  return [
    // reader/editor are read-only-ish for imported content; no column resizing
    TableWithWidth.configure({resizable: false}),
    TableRow,
    TableCell,
    TableHeader
  ];
}
